import script from "./categories-component.vue?vue&type=script&setup=true&lang=js"
export * from "./categories-component.vue?vue&type=script&setup=true&lang=js"

import "./categories-component.vue?vue&type=style&index=0&id=47af3fda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47af3fda"]])

export default __exports__